import { useState } from "react";
import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface AddFaqModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  faqData: { question: string; answer: string };
  setFaqData: Dispatch<SetStateAction<{ question: string; answer: string }>>;
  addFaq: () => void;
  id: string;
}

export default function AddFaq({
  open,
  onClose,
  setOpen,
  faqData,
  setFaqData,
  addFaq,
  id,
}: AddFaqModalProps) {
  const [error, setError] = useState(false);

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={() => {
        onClose();
        setError(false);
      }}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{id ? "Edit" : "Add"} FAQ</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>
          <form className="form" action="">
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Question"
                fullWidth
                value={faqData.question}
                onChange={(e) =>
                  setFaqData((prev) => ({ ...prev, question: e.target.value }))
                }
                hiddenLabel
              />
              {error && faqData.question == "" ? (
                <h6 className="err_msg">Question is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="control_group">
              <TextField
                variant="outlined"
                placeholder="Answer"
                fullWidth
                hiddenLabel
                multiline
                value={faqData.answer}
                onChange={(e) =>
                  setFaqData((prev) => ({ ...prev, answer: e.target.value }))
                }
                maxRows={5}
                minRows={5}
              />
              {error && faqData.answer == "" ? (
                <h6 className="err_msg">Answer is required</h6>
              ) : (
                ""
              )}
            </div>
            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                }}
              >
                Cancel
              </Button>
              <Button
                className="btn btn_primary"
                onClick={() => {
                  addFaq();
                  // setError(true);
                  //   setFaqData({ answer: "", question: "" });
                  setError(false);
                  setOpen(false);
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
